import { render, staticRenderFns } from "./BaseTextarea.vue?vue&type=template&id=7af94a02&"
import script from "./BaseTextarea.vue?vue&type=script&lang=ts&"
export * from "./BaseTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports